<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import type { ICompanyDTO, ICompanyOwnershipDTO } from "../../services/DTO";
  import type { ICompany, IOwnership } from "../../entities";
  import { formatTimestampHuman } from "../../utils/date-utils";
  import Textarea from "../Form/Fields/Textarea.svelte";
  import Button from "../../components/Button.svelte";
  import OwnershipDropdown from "../Form/Fields/Dropdown/OwnershipDropdown.svelte";
  import FormField from "../Form/FormField.svelte";
  import Icon from "../Icon.svelte";
import ClfDropdown from "../Form/Fields/Dropdown/ClfDropdown.svelte";

  export let magId: number = null;
  export let disabled: boolean = false;
  
  const dispatch = createEventDispatcher();
 
 

  function onSave() {     
    dispatch("save", magId);
  }
 

  //onMount(() => onLoad());
</script>

<div class="box">
  <h1 class="subtitle">Magazine  <Button klass="is-small" on:click={onSave} {disabled} >Salva</Button></h1>
  {#if !disabled}
  <FormField>
  <div class="columns">
    <div class="column is-12">
      <FormField>
        <ClfDropdown
          schema="MAGAZINEXX"
          required={false}
          clearVisible={false}
          bind:value={magId}
        />               
      </FormField>
    </div>
  </div>  
  </FormField>
  {/if} 
</div>